import styled from 'styled-components';
import { AHeaderSize } from './AHeader.types';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

const TwelvePx = '0.75rem';

export const Wrapper = styled.div<{ size: AHeaderSize }>`
  /* DUX-1153 Global Styles overrides:  h1, h2, h3 */
  margin-block-end: 0;

  padding-block-end: ${({ size }) => (size === AHeaderSize.TitleS ? spacers?.spacers?.[2] ?? '0.5rem' : TwelvePx)};
`;
